import { render, staticRenderFns } from "./onlineAssessment.vue?vue&type=template&id=4adc33dd&scoped=true&"
import script from "./onlineAssessment.vue?vue&type=script&setup=true&lang=js&"
export * from "./onlineAssessment.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4adc33dd",
  null
  
)

export default component.exports